import React, { useEffect, memo, useMemo } from "react";
import { Text, View, useWindowDimensions, ScrollView } from "react-native";
import CustomPressable from "../../components/customPressable/customPressable";
import { ImageComp } from "../../components/Image/Image";
// import { PLUS } from "../../assets";
import { CHEVRON_RIGHT, MINUS, PLUS } from "../../assets";
import { useCssStyle } from "../../customHook/getCssStyle";
import { getCleanUrl } from "../../utils/Helper";
import { useDispatch, useSelector } from "react-redux";
import { sendAnalytics } from "../../Redux/Actions/analyticsAction";
import { HCOMMERCE } from "../../config/Constant";
import RenderHTML from "react-native-render-html";

export const StoreLevel2 = memo((props) => {

    const getStyles = useCssStyle();
    const dispatch = useDispatch();
    const { width } = useWindowDimensions();

    const { selectedStoreItemSubType, handleStoreItemSubTypeSelect, cartItem, handleAddToCart, handleRemoveFromCart, handleItemInfo } = props || {};
    const { currentWidget } = useSelector(state => state.deviceConfigSlice);

    const { currencyDetails } = useSelector(state => state.deviceConfigSlice);
    const currencyCode = currencyDetails.code;

    const customWidgetHeaderTitleStyle = useMemo(() => {
        const style = getStyles(['widgetmainContainerHeaderTitle', 'hcommerce_storelevel2_HeaderTitle']);
        return Array.isArray(style) ? Object.assign({}, ...style) : style || {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const customWidgetHeaderSubTitleStyle = useMemo(() => {
        const style = getStyles(['widgetmainContainerHeaderSubTitle', 'hcommerce_storelevel2_HeaderSubTitle']);
        return Array.isArray(style) ? Object.assign({}, ...style) : style || {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const customWidgetTitleStyle = useMemo(() => {
        const style = getStyles(['list_itemContainer_textContainer_title', 'hcommerce_storelevel2_itemContainer_textContainer_title']);
        return Array.isArray(style) ? Object.assign({}, ...style) : style || {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const customWidgetSubTitleStyle = useMemo(() => {
        const style = getStyles(['list_itemContainer_textContainer_subtitle', 'hcommerce_storelevel2_itemContainer_textContainer_subtitle']);
        return Array.isArray(style) ? Object.assign({}, ...style) : style || {};
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {

        dispatch(sendAnalytics(HCOMMERCE, "STORE LEVEL - 2", { storeName: props.storeName, element: "widget", storeSku: currentWidget.storeSku, widgetSessionId: props.hcommerceSessionToken, subStoreName: selectedStoreItemSubType.subTypeName, subStoreSku: selectedStoreItemSubType.sku }))

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);



    return (

        <View style={getStyles(['widgetmainContainer', 'hcommerce_storelevel2_MainContainer'])} id="widgetmainContainer hcommerce_storelevel2_MainContainer">

            {
                currentWidget?.widgetHeaderImageUrl &&
                <ImageComp source={getCleanUrl(currentWidget?.widgetHeaderImageUrl)} style={getStyles(['widgetmainContainerHeaderImg', 'hcommerce_storelevel2_HeaderImg'])} id={`widgetmainContainerHeaderImg hcommerce_storelevel2_HeaderImg`} />
            }
            <ScrollView showsVerticalScrollIndicator={false}>
                <View style={getStyles(['widgetmainContainerHeaderContainer', 'hcommerce_storelevel2_HeaderContainer'])} id="widgetmainContainerHeaderContainer hcommerce_storelevel2_HeaderContainer">
                    <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'hcommerce_storelevel2_HeaderTitleContainer'])} id="widgetmainContainerHeaderTitleContainer hcommerce_storelevel2_HeaderTitleContainer">
                        <RenderHTML
                            contentWidth={width}
                            baseStyle={customWidgetHeaderTitleStyle}
                            source={{ html: selectedStoreItemSubType.subTypeName}}
                            systemFonts={[customWidgetHeaderTitleStyle.fontFamily]}
                            id={`widgetmainContainerHeaderTitle hcommerce_storelevel2_HeaderTitle`}
                        />
                        <RenderHTML
                            contentWidth={width}
                            baseStyle={customWidgetHeaderSubTitleStyle}
                            source={{ html: selectedStoreItemSubType.subTypeDescription || ''}}
                            systemFonts={[customWidgetHeaderSubTitleStyle.fontFamily]}
                            id={`widgetmainContainerHeaderSubTitle hcommerce_storelevel2_HeaderSubTitle`}
                        />
                    </View>
                </View>

                <View style={getStyles(['widgetmainContainerChildContainer', 'hcommerce_storelevel2_MainContainerChildContainer'])} id="widgetmainContainerChildContainer hcommerce_storelevel2_MainContainerChildContainer">

                    {/* Render nested subcategories if they exist */}
                    {selectedStoreItemSubType?.subMenu && selectedStoreItemSubType.subMenu.length > 0 && (
                        <View style={getStyles(['hcommerce_storelevel2_ChildContainer_items_container'])} id="hcommerce_storelevel2_ChildContainer_items_container">
                            {selectedStoreItemSubType.subMenu.map((nestedSubCategory) => {
                                const imageUri = nestedSubCategory.storeItemTypeImages?.find(image => image.imageType === "LARGE")?.imagePath || nestedSubCategory.storeItemTypeImages?.[0]?.imagePath;

                                return (
                                    <CustomPressable key={nestedSubCategory.id} style={getStyles(['list_itemContainer', 'hcommerce_storelevel2_itemContainer'])} onPress={() => handleStoreItemSubTypeSelect(nestedSubCategory)} id={`list_itemContainer hcommerce_storelevel2_itemContainer ${nestedSubCategory.id}`}>

                                        <View style={getStyles(['list_itemContainer_image', 'hcommerce_storelevel2_itemContainer_image'])} id="list_itemContainer_image hcommerce_storelevel2_itemContainer_image">
                                            {imageUri &&
                                                <ImageComp
                                                    source={getCleanUrl(imageUri)}
                                                    style={getStyles(["hcommerce_storelevel2_item_image"])}
                                                    id="hcommerce_storelevel2_item_image"
                                                />
                                            }
                                        </View>
                                        <View style={getStyles(['list_itemContainer_textContainer', 'hcommerce_storelevel2_itemContainer_textContainer'])} id="list_itemContainer_textContainer hcommerce_storelevel2_itemContainer_textContainer">
                                            <RenderHTML
                                                contentWidth={width}
                                                baseStyle={customWidgetTitleStyle}
                                                source={{ html: nestedSubCategory.subTypeName}}
                                                systemFonts={[customWidgetTitleStyle.fontFamily]}
                                                id={`list_itemContainer_textContainer_title hcommerce_storelevel2_itemContainer_textContainer_title_${nestedSubCategory.id}`}
                                                defaultTextProps={{
                                                    numberOfLines: 1
                                                }}
                                            />
                                            {nestedSubCategory.subTypeDescription &&
                                                <RenderHTML
                                                    contentWidth={width}
                                                    baseStyle={customWidgetSubTitleStyle}
                                                    source={{ html: nestedSubCategory.subTypeDescription}}
                                                    systemFonts={[customWidgetSubTitleStyle.fontFamily]}
                                                    id={`list_itemContainer_textContainer_subtitle hcommerce_storelevel2_itemContainer_textContainer_subtitle_${nestedSubCategory.id}`}
                                                    defaultTextProps={{
                                                        numberOfLines: 1
                                                    }}
                                                />
                                            }
                                        </View>

                                        <View style={getStyles(['list_itemContainer_arrow', 'hcommerce_storelevel2_itemContainer_arrow'])} id="list_itemContainer_arrow hcommerce_storelevel2_itemContainer_arrow">
                                            <ImageComp source={CHEVRON_RIGHT} />
                                        </View>
                                    </CustomPressable>
                                )
                            })}
                        </View>
                    )}


                    {/* Render items in the selected subcategory */}
                    {selectedStoreItemSubType?.storeItem && selectedStoreItemSubType.storeItem.length > 0 && (
                        <View style={getStyles(['hcommerce_storelevel2_ChildContainer_items_container'])} id="hcommerce_storelevel2_ChildContainer_items_container">
                            {selectedStoreItemSubType.storeItem.map((item) => {

                                const totalQuantity = cartItem.reduce((total, cartItem) => {
                                    return cartItem.itemInfo.id == item.id ? total + cartItem.quantity : total;
                                }, 0);

                                // Determine if item has addons
                                const hasItemAddOns = (item.addOnGroupReferences && item.addOnGroupReferences.length > 0) ||
                                                     (item.addOnItem && item.addOnItem.length > 0);

                                const imageUri = item.storeItemImages?.find(image => image.imageType === "LARGE")?.imagePath || item.storeItemImages?.[0]?.imagePath;

                                return (
                                    <CustomPressable key={item.id} style={getStyles(['list_itemContainer', 'hcommerce_storelevel2_itemContainer'])} onPress={() => { handleItemInfo({...item, hasItemAddOns}) }} id={`list_itemContainer hcommerce_storelevel2_itemContainer ${item.id}`}>

                                        <View style={getStyles(['list_itemContainer_image', 'hcommerce_storelevel2_itemContainer_image'])} id={`list_itemContainer_image hcommerce_storelevel2_itemContainer_image ${item.id}`}>
                                            {imageUri &&
                                                <ImageComp
                                                    source={getCleanUrl(imageUri)}
                                                    style={getStyles(["hcommerce_storelevel2_item_image"])}
                                                    id="hcommerce_storelevel2_item_image"
                                                />
                                            }
                                        </View>
                                        <View style={getStyles(['list_itemContainer_textContainer', 'hcommerce_storelevel2_itemContainer_textContainer'])} id={`list_itemContainer_textContainer hcommerce_storelevel2_itemContainer_textContainer ${item.id}`}>
                                            <RenderHTML
                                                contentWidth={width}
                                                baseStyle={customWidgetTitleStyle}
                                                source={{ html: item.itemName}}
                                                systemFonts={[customWidgetTitleStyle.fontFamily]}
                                                id={`list_itemContainer_textContainer_title hcommerce_storelevel2_itemContainer_textContainer_title_${item.id}`}
                                                defaultTextProps={{
                                                    numberOfLines: 1
                                                }}
                                            />
                                            {item.itemDescription &&
                                                <RenderHTML
                                                    contentWidth={width}
                                                    baseStyle={customWidgetSubTitleStyle}
                                                    source={{ html: item.itemDescription}}
                                                    systemFonts={[customWidgetSubTitleStyle.fontFamily]}
                                                    id={`list_itemContainer_textContainer_subtitle hcommerce_storelevel2_itemContainer_textContainer_subtitle_${item.id}`}
                                                    defaultTextProps={{
                                                        numberOfLines: 1
                                                    }}
                                                />
                                            }


                                            <View style={getStyles(['list_itemContainer_textContainer_tertiaryContainer', 'hcommerce_storelevel2_itemContainer_textContainer_tertiaryContainer'])} id={`list_itemContainer_textContainer_tertiaryContainer hcommerce_storelevel2_itemContainer_textContainer_tertiaryContainer ${item.id}`} >

                                                <Text style={getStyles(['list_itemContainer_textContainer_title', 'hcommerce_storelevel2_itemContainer_textContainer_title'])} id="list_itemContainer_textContainer_title hcommerce_storelevel2_itemContainer_textContainer_title" >{currencyCode + item.itemPrice}</Text>

                                                <View style={getStyles(['additem_controls'])} id="additem_controls" >
                                                    {totalQuantity > 0 &&
                                                        <CustomPressable onPress={() => handleRemoveFromCart({...item, hasItemAddOns})} style={getStyles(['additem_controls_sub_container'])} id={`additem_controls_sub_container`}>
                                                            <ImageComp source={MINUS} style={getStyles(['additem_controls_sub_container_img'])} id="additem_controls_sub_container_img"/>
                                                        </CustomPressable>
                                                    }
                                                    {totalQuantity > 0 &&
                                                        <Text style={getStyles(['additem_controls_qty_text'])} id="additem_controls_qty_text">{totalQuantity}</Text>
                                                    }
                                                    <CustomPressable onPress={() => handleAddToCart({...item, hasItemAddOns})} style={getStyles(['additem_controls_sub_container'])} id="additem_controls_sub_container">
                                                        <ImageComp source={PLUS} style={getStyles(['additem_controls_sub_container_img'])} id="additem_controls_sub_container_img"/>
                                                    </CustomPressable>

                                                </View>

                                            </View>
                                        </View>
                                    </CustomPressable>
                                )
                            })}
                        </View>
                    )}
                </View>
            </ScrollView>
        </View>
    );
});

